<div class="container-fluid main-page main-page-padding">
  <div class="page-title d-flex align-items-center justify-content-between">
    <h2 class="page-header">Notification Centre</h2>
    <div *ngIf="!loading" class="counter" [ngClass]="{'counter-red': unreadCount > 0}">
        <span class="number" [ngClass]="{'red': unread.length > 0}">{{ unreadCount }}</span>
        <span class="words">Unread</span>
    </div>
  </div>
  <div class="page-content">
    <div *ngIf="loading" class="text-center">
      <app-loading-wbac-animation></app-loading-wbac-animation>
    </div>
    <div *ngIf="!loading">
        <div class="notification-container" *ngIf="unread.length > 0">
            <div class="date-block" *ngFor="let group of unread; let i = index">
                <div class="date-label">{{ group.notificationDay }}</div>
                <div class="notification row" *ngFor="let notification of group.notifications; let j = index">
                    <div class="col-2 notification-time unread">{{ notification.dateAdded  | date: 'HH:mm' }}</div>
                    <div class="col-10 notification-desc-container">
                        <span class="notification-icon" [ngClass]="{'pog': notification.notificationType === 2}"></span>
                        <span class="notification-desc">{{ notification.description }}</span>
                        <span class="go-icon" (click)="dealWithIt(notification)"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="read-title" *ngIf="read.length > 0" [ngClass]="{'no-unread': unread.length == 0}">Read</div>
        <div class="notification-container" *ngIf="read.length > 0">
            <div class="date-block" *ngFor="let group of read; let i = index">
                <div class="date-label">{{ group.notificationDay }}</div>
                <div class="notification row" *ngFor="let notification of group.notifications; let j = index">
                    <div class="col-2 notification-time">{{ notification.dateAdded  | date: 'HH:mm' }}</div>
                    <div class="col-10 notification-desc-container">
                        <span class="notification-icon" [ngClass]="{'pog': notification.notificationType === 2}"></span>
                        <span class="notification-desc">{{ notification.description }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>
